export default "__VITE_ASSET__Bppzd81g__"